import BaseFooterMcom from './BaseFooter.mcom';
import BaseFooterBcom from './BaseFooter.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? BaseFooterBcom : BaseFooterMcom;
